 <template>
  <div>
      <div class="top_box">
        <img :src="myriches.levelimg" alt />
        <div class="grade_box">
          {{caifu}}:
          <i>{{myriches.thislevel}}级</i>
        </div>
        <!-- 进度条 -->
        <div class="pro_box">
          <div class="jindu" :style="{ background: probgcolora }">
            <div class="jindu_now" :style="{ width: prowidth + '%' , background: probgcolor }">
              <p :style="{ background: probgcolor }"></p>
            </div>
          </div>
          <div class="flex-box">
            <p>Lv.{{myriches.thislevel}}</p>
            <div class="flex_center">
              升级还需
              <i>{{myriches.nextexp}}</i> {{expname}}
            </div>
            <p>Lv.{{myriches.nextlevel}}</p>
          </div>
        </div>
      </div>

      <!--  -->
      
    </div>
</template>

<script>
export default {
props: ["myriches","probgcolor","probgcolora","prowidth","caifu","expname"],
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.grade_caifu {
  background-color: #fff;
  height: 100vh;
}
.top_box > img {
  width: 20%;
}
.top_box i {
  font-style: normal;
}
.top_box {
  width: 100%;
  text-align: center;
  padding: 40px 0;
  .grade_box {
    margin-top: 10px;
    color: #2c2c2c;
    font-weight: 600;
  }
  .pro_box {
    width: 90%;
    margin: 0 auto;
    margin-top: 28px;
    .jindu {
      position: relative;
      width: 100%;
      height: 4px;
      border-radius: 4px;
      // background-color: rgba(255, 92, 54, .2);
      .jindu_now {
        position: absolute;
        left: 0;
        height: 4px;
        // background-color: rgb(255, 92, 54);
        p {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          // background: rgb(255, 92, 54);
          position: absolute;
          right: 0;
          top: -2px;
        }
      }
    }
    .flex-box {
      justify-content: space-between;
      margin-top: 8px;
      p {
        color: #b7b7b7;
      }
      .flex_center {
        font-size: 0.9rem;
        color: #b7b7b7;
        i {
          color: #353535;
          font-weight: 600;
        }
      }
    }
  }
}

</style>